import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  computed,
  inject,
  input
} from '@angular/core';
import { MatTable, MatTableModule } from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { DateFormatPipe, MomentModule } from 'ngx-moment';
import { lastValueFrom } from 'rxjs';
import { HireItem } from 'src/app/models';
import { CustomerNamePipe } from 'src/app/shared/pipes/customer-name.pipe';
import { HlCurrencyPipe } from 'src/app/shared/pipes/hl-currency.pipe';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ItemService } from 'src/app/shared/services/item.service';

@Component({
  selector: 'app-hire-history-table',
  standalone: true,
  imports: [
    MatTableModule,
    RouterLink,
    HlCurrencyPipe,
    CustomerNamePipe,
    MomentModule,
    AsyncPipe
  ],
  templateUrl: './hire-history-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HireHistoryTableComponent {

  itemId = input<number>();
  productId = input<number>();
  itemService = inject(ItemService);

  hireHistoryQuery = injectQuery(() => ({
    enabled: Boolean(this.itemId() && this.productId()),
    queryKey: ['product', this.productId(), 'item', this.itemId(), 'hireHistory'],
    queryFn: () =>
      lastValueFrom(this.itemService.getWithHireHistory(this.productId(), this.itemId()))
  }));

  hireHistory = computed(() => this.hireHistoryQuery.data()?.hire_items.filter(hi => hi.deleted === 0) ?? []);
  loading = this.hireHistoryQuery.isLoading;
  error = this.hireHistoryQuery.error;

  columns = ['docket', 'customer', 'on_hire', 'off_hire', 'charge'];

  dateFormat = ConfigService.dates.shortDateTimeFormat;
}
